module.exports = __webpack_public_path__ + "static/media/2_Step 2 & 3.018cfee1.JPG";